import autobind from 'autobind-decorator';
import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction, Dispatch } from 'redux';
import { CustomDialog } from '@shared/ui-components';

import { State } from 'common/interfaces/state';
import { KreoDialogActions } from 'common/UIKit';
import { DialogWrapper } from 'common/UIKit/dialogs/dialog-wrapper';

interface OwnProps<T> {
  name: string;
  title: string;
  text: string;
  children?: JSX.Element;
  zIndex?: number;
  confirmButtonText?: string;
  cancelButtonText?: string;
  onConfirm?: (data: T) => void;
  onCancel?: (data: T) => void;
}

interface DispatchProps {
  onCloseDialog: (name: string) => void;
}

interface ReduxProps<T> {
  data: T;
}

interface Props<T> extends OwnProps<T>, ReduxProps<T>, DispatchProps {
}

class ConfirmationDialogComponent<T> extends React.Component<Props<T>> {
  public render(): React.ReactNode {
    const { name, onConfirm, title, text, children, confirmButtonText, cancelButtonText, zIndex } = this.props;

    return (
      <DialogWrapper name={name}>
        <CustomDialog
          mainText={title}
          secondaryText={text}
          submitText={onConfirm && confirmButtonText}
          onSubmit={onConfirm && this.onSubmit}
          rejectText={cancelButtonText}
          onReject={this.onClose}
          zIndex={zIndex}
        >
          {children}
        </CustomDialog>
      </DialogWrapper>
    );
  }

  @autobind
  private onSubmit(): void {
    this.props.onConfirm(this.props.data);
    this.props.onCloseDialog(this.props.name);
  }

  @autobind
  private onClose(): void {
    const { onCancel, onCloseDialog } = this.props;

    onCloseDialog(this.props.name);
    if (onCancel) {
      onCancel(this.props.data);
    }
  }
}

function mapStateToProps<T>(state: State, ownProps: OwnProps<T>): ReduxProps<T> {
  return {
    data: state.dialog[ownProps.name],
  };
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): DispatchProps => {
  return {
    onCloseDialog: (name: string) => dispatch(KreoDialogActions.closeDialog(name)),
  };
};

export const ConfirmationDialog = connect(mapStateToProps, mapDispatchToProps)(ConfirmationDialogComponent);
